import React, { lazy, Suspense } from 'react';

import { envIsCanada, envIsMexico, envIsNormal } from '@/constants/constants';
import HeaderBannerCarousel from '@/components/shared/banners/HeaderBannerCarousel';
import { useSelector } from 'react-redux';
import { selectHeaderBanners } from '@/store/cms/header-banners/selectors';
import { useLocation } from 'react-use';

const GamesHeaderSweden = lazy(() => import('./GamesHeaderSweden'));
const GamesSearchHeader = lazy(() => import('./GamesSearchHeader'));

const GamesHeader = () => {
  const headerBanners = useSelector(selectHeaderBanners);
  const defaultHeaderBanners = headerBanners.filter(banner => banner.pages.length === 0);

  const location = useLocation();
  const pathParts = location.pathname?.split('/').filter(Boolean) || [];
  const category = pathParts[pathParts.length - 1];

  const filteredHeaderBanners = headerBanners.filter(banner => {
    return banner.pages?.includes(category);
  });

  const renderHeader = () => {
    if (envIsNormal() || envIsMexico() || envIsCanada()) {
      return (
        <HeaderBannerCarousel
          headerBanners={
            filteredHeaderBanners.length > 0 ? filteredHeaderBanners : defaultHeaderBanners
          }
        />
      );
    }

    return <GamesHeaderSweden />;
  };

  return (
    <Suspense fallback={<div>Loading header...</div>}>
      <GamesSearchHeader />
      {renderHeader()}
    </Suspense>
  );
};

export default GamesHeader;
